module.exports = ".ck-content .image>figcaption{color:#333;background-color:#f7f7f7;padding:.6em;font-size:.75em;outline-offset:-1px}"


//////////////////
// WEBPACK FOOTER
// ./node_modules/postcss-loader/lib??ref--1-1!./node_modules/@ckeditor/ckeditor5-image/theme/imagecaption.css
// module id = 66
// module chunks = 0